import styled from "styled-components";

export const AddInfoButtonDiv = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  width: 150px;
  border-radius: 20px;
  border: 2px solid #104467;
  padding: 10px;
  gap: 10px;

  &:hover {
    cursor: pointer;
  }
`;

export const AddInfoButtonTextDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #104467;
`;
